@if (mainScore() || skillScores().length) {
  <div nrTourAnchor="scores" class="pronunciation-scores">
    @if (mainScore(); as score) {
      <ng-container
        *ngTemplateOutlet="card; context: { $implicit: score, main: true }"
      ></ng-container>
    }
    @if (skillScores().length) {
      <ul class="pronunciation-scores__skills">
        @for (score of skillScores(); track score.label) {
          <li class="pronunciation-scores__item">
            <ng-container *ngTemplateOutlet="card; context: { $implicit: score }"></ng-container>
          </li>
        }
      </ul>
    }
  </div>
}

<ng-template #card let-score let-main="main">
  <div
    class="pronunciation-scores__card"
    [class.pronunciation-scores__card--main]="main"
    [ngClass]="score.style"
  >
    <svg
      class="pronunciation-scores__ring"
      viewBox="0 0 36 36"
      aria-hidden="true"
      focusable="false"
    >
      <circle class="pronunciation-scores__track" cx="18" cy="18" r="15.9155" />
      <circle
        class="pronunciation-scores__progress"
        cx="18"
        cy="18"
        r="15.9155"
        [attr.stroke-dasharray]="score.ringDashArray"
      />
    </svg>
    <span class="pronunciation-scores__text">
      <span class="pronunciation-scores__label">{{ score.label | translate }}</span>
      <span class="pronunciation-scores__value">{{ score.value | number: '1.0-0' }}/100</span>
    </span>
  </div>
</ng-template>
